import { Directive, Input } from '@angular/core';

import { LMSCONSTANTS } from '@lmsConstants';

@Directive({
  selector: '[lmsSelectOption]',
  standalone: true,
})
export class LMSSelectOptionDirective {
  // Compatibility shim retained while legacy templates are phased out.
  @Input() constantName: LMSCONSTANTS;
  @Input() addDefault = false;
  @Input() setFirstAsValue = false;
}
